import React, { useState, useEffect } from 'react';
import PageGrid from 'shared/grids/old/PageGrid';
import { GridColumn } from '@progress/kendo-react-grid';
import Modal from 'shared/modals/Modal';

const initialSort = [
  { field: 'name', dir: 'asc' },
];

const QuotesModal = ({
  quotes,
  onQuoteSelected,
  onClose
}) => {

  const handleRowSelect = selectedQuote => {
    if (onQuoteSelected) {
      onQuoteSelected(selectedQuote);
      onClose();
    }
  }

  const getData = () => Promise.resolve({
    data: quotes,
    total: quotes.length
  });


  return (
    <Modal isOpen={true} title={`Select Quote`} handleClose={onClose} containerStyle='medium' width={700}>
      <PageGrid
        name={'Select Quote'}
        getData={getData}
        searchParams={{}}
        onRowSelect={handleRowSelect}
        initialSort={initialSort}
      >
        <GridColumn title="#" field="id" />
        <GridColumn title="Name" field="name" />
      </PageGrid>
    </Modal >
  )
};

export default QuotesModal;